import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Container, Col, Row } from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faClock from '@fortawesome/fontawesome-free-solid/faClock';
import faClipboardList from '@fortawesome/fontawesome-free-solid/faClipboardList';
import faWrench from '@fortawesome/fontawesome-free-solid/faWrench';
import faIndustry from '@fortawesome/fontawesome-free-solid/faIndustry';
import faTint from '@fortawesome/fontawesome-free-solid/faTint';
import faUsers from '@fortawesome/fontawesome-free-solid/faUsers';
import faFileAlt from '@fortawesome/fontawesome-free-solid/faFileAlt';
import faMap from '@fortawesome/fontawesome-free-solid/faMap';
import faMapPin from '@fortawesome/fontawesome-free-solid/faMapPin';
import faStopwatch from '@fortawesome/fontawesome-free-solid/faStopwatch';
import faDollarSign from '@fortawesome/fontawesome-free-solid/faDollarSign';
import * as siteActions from '../../actions/siteActions';
import * as systemActions from '../../actions/systemActions';

import { hasRole } from '../../services/authService';

class Dashboard extends Component {
  componentWillMount() {
    if (this.props.systems.length > 0) return;
    this.props.actions.loadSystems();
    this.props.actions.loadSites();
  }

  render() {
    return (
      <div>
        <Container fluid={true}>
          <Row>
            <Col md={12}>
              <h1 className="text-center my-4">Dashboard</h1>
            </Col>
          </Row>
          <Row>
            <Col md={2} />
            <Col md={8}>
              <Row>
                <Col md={12}>
                  <Row>
                    {hasRole('ROLE_MANAGER') ? (
                      <Col
                        md={4}
                        className="text-center my-4 db-icon"
                        tag={Link}
                        to={'/time-admin'}
                      >
                        <FontAwesomeIcon
                          icon={faStopwatch}
                          size="5x"
                          className="mb-4"
                        />
                        <h2>Time Admin</h2>
                      </Col>
                    ) : (
                      <Col
                        md={4}
                        className="text-center my-4 db-icon"
                        tag={Link}
                        to={'/time-cards'}
                      >
                        <FontAwesomeIcon
                          icon={faClock}
                          size="5x"
                          className="mb-4"
                        />
                        <h2>Time Entry</h2>
                      </Col>
                    )}

                    {hasRole('ROLE_MANAGER') && (
                      <Col
                        md={4}
                        className="text-center my-4 db-icon"
                        tag={Link}
                        to={'/pay'}
                      >
                        <FontAwesomeIcon
                          icon={faDollarSign}
                          size="5x"
                          className="mb-4"
                        />
                        <h2>Pay</h2>
                      </Col>
                    )}

                    {hasRole('ROLE_MANAGER') && (
                      <Col
                        md={4}
                        className="text-center my-4 db-icon"
                        tag={Link}
                        to={'/daily-logs'}
                      >
                        <FontAwesomeIcon
                          icon={faClipboardList}
                          size="5x"
                          className="mb-4"
                        />
                        <h2>Daily Log</h2>
                      </Col>
                    )}

                    {hasRole('ROLE_EMPLOYEE') && (
                      <Col
                        md={4}
                        className="text-center my-4 db-icon"
                        tag={Link}
                        to={'/repair-logs'}
                      >
                        <FontAwesomeIcon
                          icon={faWrench}
                          size="5x"
                          className="mb-4"
                        />
                        <h2>Repair Log</h2>
                      </Col>
                    )}

                    {hasRole('ROLE_EMPLOYEE') && (
                      <Col
                        md={4}
                        className="text-center my-4 db-icon"
                        tag={Link}
                        to={'/water'}
                      >
                        <FontAwesomeIcon
                          icon={faTint}
                          size="5x"
                          className="mb-4"
                        />
                        <h2>Water</h2>
                      </Col>
                    )}

                    {hasRole('ROLE_EMPLOYEE') && (
                      <Col
                        md={4}
                        className="text-center my-4 db-icon"
                        tag={Link}
                        to={'/wastewater'}
                      >
                        <FontAwesomeIcon
                          icon={faIndustry}
                          size="5x"
                          className="mb-4"
                        />
                        <h2>Wastewater</h2>
                      </Col>
                    )}

                    {hasRole('ROLE_MANAGER') && (
                      <Col
                        md={4}
                        className="text-center my-4 db-icon"
                        tag={Link}
                        to={'/reports'}
                      >
                        <FontAwesomeIcon
                          icon={faFileAlt}
                          size="5x"
                          className="mb-4"
                        />
                        <h2>Reports</h2>
                      </Col>
                    )}

                    {hasRole('ROLE_MANAGER') && (
                      <Col
                        md={4}
                        className="text-center my-4 db-icon"
                        tag={Link}
                        to={'/systems'}
                      >
                        <FontAwesomeIcon
                          icon={faMap}
                          size="5x"
                          className="mb-4"
                        />
                        <h2>Systems</h2>
                      </Col>
                    )}

                    {hasRole('ROLE_MANAGER') && (
                      <Col
                        md={4}
                        className="text-center my-4 db-icon"
                        tag={Link}
                        to={'/sites'}
                      >
                        <FontAwesomeIcon
                          icon={faMapPin}
                          size="5x"
                          className="mb-4"
                        />
                        <h2>Sites</h2>
                      </Col>
                    )}

                    {hasRole('ROLE_MANAGER') && (
                      <Col
                        md={4}
                        className="text-center my-4 db-icon"
                        tag={Link}
                        to={'/users'}
                      >
                        <FontAwesomeIcon
                          icon={faUsers}
                          size="5x"
                          className="mb-4"
                        />
                        <h2>Users</h2>
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    systems: state.systems,
    sites: state.sites,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...systemActions, ...siteActions }, dispatch),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Dashboard)
);



// WEBPACK FOOTER //
// ./src/components/common/Dashboard.js